export default "__VITE_PUBLIC_ASSET__ceaefda8__"